var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoice-items-list text-grey-9" },
    [
      _vm.showHeadingInput
        ? _c("q-input", {
            staticClass: "q-mb-sm",
            attrs: {
              "float-label": _vm.$t("invoice_block_heading"),
              "hide-underline": ""
            },
            model: {
              value: _vm.heading,
              callback: function($$v) {
                _vm.heading = $$v
              },
              expression: "heading"
            }
          })
        : _vm._e(),
      _c(
        "table",
        { staticClass: "line-items-table" },
        [
          _c("thead", [
            _c("tr", [
              _c("th"),
              _c("th", { staticClass: "text-left" }, [
                _vm._v(_vm._s(_vm.$t("description")))
              ]),
              _c("th", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.$t("quantity")))
              ]),
              _c("th", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.$t("price")))
              ]),
              _vm.hasDiscount
                ? _c("th", { staticClass: "text-right" }, [
                    _vm._v(_vm._s(_vm.$t("discount")))
                  ])
                : _vm._e(),
              _c("th", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.$t("sales_tax")))
              ]),
              _c("th", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.$t("sum_net")))
              ]),
              _c("th")
            ])
          ]),
          _c(
            "draggable",
            {
              attrs: {
                element: "tbody",
                options: { group: "items", handle: ".drag-item-handle" }
              },
              model: {
                value: _vm.children,
                callback: function($$v) {
                  _vm.children = $$v
                },
                expression: "children"
              }
            },
            _vm._l(_vm.lineItems.children, function(lineItem, index) {
              return _c("line-items-table-row", {
                key: index + "-" + lineItem.itemName,
                attrs: {
                  lineItem: lineItem,
                  currency: _vm.currency,
                  showDiscount: _vm.hasDiscount
                },
                on: {
                  remove: function($event) {
                    _vm.handleRemoveItem(index)
                  },
                  update: function($event) {
                    _vm.handleUpdateItem(index, $event)
                  }
                }
              })
            })
          )
        ],
        1
      ),
      _vm.lineItems.children.length === 0
        ? _c("p", { staticClass: "text-center q-mt-md text-grey-6" }, [
            _vm._v("\n    " + _vm._s(_vm.$t("line_items_empty_text")) + "\n  ")
          ])
        : _vm._e(),
      _vm.showDeleteButton
        ? _c(
            "q-btn",
            {
              staticClass: "q-mt-sm",
              attrs: { color: "grey-8", size: "sm", flat: "" },
              on: { click: _vm.handleRemoveBlock }
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$t("delete_line_item_group")) + "\n  "
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }